<script>
  import Layout from '@layout/main'

  export default {
    components: { Layout },
    props: {
      resource: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        reciprocal: 10,
        reciprocalTimer: null,
        toBackHomeTimer: null,
      }
    },
    mounted() {
      const initReciprocalTimer = () => {
        this.reciprocalTimer = setInterval(() => {
          if(this.reciprocal > 0) {
            this.reciprocal -= 1
          }
        }, 1000)
      }
      const timeToBackHome = () => {
        this.toBackHomeTimer = setTimeout(() => {
          this.goBackHome();
        }, 9000)
      };

      initReciprocalTimer();
      timeToBackHome()
    },
    destroyed() {
      const clearReciprocalTimer = () => {
        clearInterval(this.reciprocalTimer);
      };
      const cleartoBackHomeTimer = () => {
        clearTimeout(this.toBackHomeTimer);
      };
      clearReciprocalTimer();
      cleartoBackHomeTimer();
    },
    methods: {
      goBackHome() {
        this.$router.push({
          name: 'home'
        })
      }
    }
  }
</script>
<template>
  <Layout>
    <section :class="$style.notFound">
      <div class="container">
        <div class="row">
          <div class="col-12 align-self-center text-center">
            <h3 class="notFound__title">無法找到您要的頁面</h3>
            <p class="text-gray-6 mt-md-5 mt-4 noFound__content">
              很抱歉，您參訪的頁面已經不存在
              <br>請前往首頁
            </p>
            <BaseButton
              class="isStylePrimary mt-4 isCol4 isRadius"
              :to="{ name: 'home' }"
            >
              前往首頁
            </BaseButton>
            <p class="text-gray-5 text-base mt-3">前往首頁倒數：{{ reciprocal }}s倒數</p>
          </div>
        </div>
      </div>
    </section>
  </Layout>
</template>
<style lang="scss" module>
  .notFound {
    padding-top: 8.25rem;
    padding-bottom: 8.25rem;

    @include max-md {
      padding-top: 4.375rem;
      padding-bottom: 4.375rem;
    }

    :global {
      .notFound {
        &__round {
          width: 30vw;
          height: 30vw;
          margin: 0 auto;
          text-align: center;
          background: $color-gray-2;
          border-radius: 100%;
        }

        &__title {
          font-size: 2.5rem;

          @include max-md {
            font-size: 1.8rem;
          }
        }

        &__content {
          line-height: 1.8;
        }
      }
    }
  }
</style>
